import React from 'react';
import DropDownItem from './DropDownItem';
import './index.scss';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import ScrollComponent from '../ScrollComponent';
import { connect } from 'react-redux';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
      isShowDropDown: false,
      inputText: null,
      inputKey: null,
    };
    this.buttonRef = React.createRef();
    this.listItemRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowDropDown } = this.state;
    if (isShowDropDown) {
      window.addEventListener('mousedown', this.onClickOutside);
    } else {
      window.removeEventListener('mousedown', this.onClickOutside);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.onClickOutside);
  }

  changeInputText = (key, text) => {
    this.setState({ inputKey: key, inputText: text });
  };

  toggleHover = isHover => {
    this.setState({ isHover });
  };

  toggleDropDown = isShowDropDown => {
    this.setState({ isShowDropDown });
  };

  resetDropDown = (isShowDropDown, isHover) => {
    this.setState({ isShowDropDown, isHover });
  };

  onClickOutside = e => {
    e.preventDefault();
    e.stopPropagation();
    const isNotInListItem =
      this.listItemRef.current && !this.listItemRef.current.contains(e.target);
    if (
      this.state.isShowDropDown &&
      e.target !== this.buttonRef.current &&
      isNotInListItem
    ) {
      this.setState({ isShowDropDown: false, isHover: false });
      window.removeEventListener('mousedown', this.onClickOutside);
    }
  };

  isShowTooltip = value => {
    const { listDataByKey, keyShowTooltip, keyTitle } = this.props;

    return (
      listDataByKey[value] &&
      listDataByKey[value][keyTitle] &&
      keyShowTooltip[listDataByKey[value][keyTitle]]
    );
  };

  getTooltip = (value, optionText) => {
    const { tooltipText } = this.props;

    return tooltipText
      ? this.isShowTooltip(value) && I18n.t(tooltipText)
      : optionText;
  };

  renderCurrentOption = () => {
    const { id, currentKey, listDataByKey, keyTitle, isI18n } = this.props;
    const tmpCurrentOptionText = listDataByKey[currentKey]
      ? listDataByKey[currentKey][keyTitle]
      : '';

    const currentOptionText = isI18n
      ? I18n.t(tmpCurrentOptionText)
      : tmpCurrentOptionText;

    return (
      <button
        type="button"
        ref={this.buttonRef}
        className={`btn drop-cus dropdown-toggle text-truncate ${
          id === currentKey ? 'dropdown-active' : ''
        }`}
        onClick={e => this.toggleDropDown(true, e)}
        title={this.getTooltip(currentKey, currentOptionText)}
      >
        {currentOptionText}
      </button>
    );
  };

  renderDropDownOptions = () => {
    const {
      currentKey,
      listDataByKey,
      listKey,
      keyTitle,
      isEditable,
      change,
      update,
      deleteAction,
      isI18n,
      tooltipText,
      keyShowTooltip,
    } = this.props;

    return (
      <div
        ref={this.listItemRef}
        className="dropdown-menu drop-mecus show"
        style={{
          position: 'absolute',
          willChange: 'transform',
          top: '0px',
          left: '0px',
          transform: 'translate3d(0px, 24px, 0px)',
        }}
      >
        <div>
          <ScrollComponent appendStyle={{ maxHeight: 145 }}>
            {listKey.reduce((result, value) => {
              if (listDataByKey[value] && listDataByKey[value].isNotShow) {
                return result;
              }

              return result.concat(
                <DropDownItem
                  listDataByKey={listDataByKey}
                  isEditable={isEditable}
                  canNotDelete={listDataByKey[value].canNotDelete}
                  change={change}
                  currentKey={currentKey}
                  keyTitle={keyTitle}
                  key={value}
                  value={value}
                  isI18n={isI18n}
                  isHover={this.state.isHover}
                  toggleDropDown={this.toggleDropDown}
                  resetDropDown={this.resetDropDown}
                  changeInputText={this.changeInputText}
                  deleteAction={deleteAction}
                  update={update}
                  toggleHover={this.toggleHover}
                  tooltipText={tooltipText}
                  keyShowTooltip={keyShowTooltip}
                />,
              );
            }, [])}
          </ScrollComponent>
        </div>
      </div>
    );
  };

  render() {
    const { isShowDropDown } = this.state;
    return (
      <div className="item-filter">
        <div
          className="btn-group"
          style={{ zIndex: isShowDropDown ? 9999 : 4 }}
        >
          {this.renderCurrentOption()}
          {isShowDropDown && this.renderDropDownOptions()}
        </div>
      </div>
    );
  }
}

DropDown.propTypes = {
  id: PropTypes.any,
  currentKey: PropTypes.any,
  listKey: PropTypes.array,
  listDataByKey: PropTypes.object,
  change: PropTypes.func,
  keyTitle: PropTypes.string,
  isEditable: PropTypes.bool,
  update: PropTypes.func,
  deleteAction: PropTypes.func,
  isI18n: PropTypes.bool,
  keyShowTooltip: PropTypes.object,
};

DropDown.defaultProps = {
  id: '',
  currentKey: '',
  listKey: [],
  listDataByKey: {},
  change: () => {},
  keyTitle: 'name',
  isEditable: false,
  update: () => {},
  deleteAction: () => {},
  isI18n: false,
  keyShowTooltip: {},
};

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
  };
};

export default connect(mapStateToProps)(DropDown);
